import { Zap } from "lucide-react";

const items = [
  "Missed call → Instant SMS recovery",
  "Qualified contract",
  "24/7 dispatch backfill",
  "Answers missed calls in seconds, 24/7",
  "Weekly revenue report",
  "No new hires required",
  "Emergency escalation to humans",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/[0.08] bg-[#0E1117] py-5"
    >
      <div className="marquee-track flex w-max items-center">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="whitespace-nowrap font-display text-sm font-semibold uppercase tracking-[0.2em] text-slate-400">
              {item}
            </span>
            <Zap className="mx-8 h-3.5 w-3.5 shrink-0 text-[#F25F22]" />
          </div>
        ))}
      </div>
    </div>
  );
}
